import { Loader } from "rizzui/loader";
import HubspotIcon from "../../../../assets/hubspot";
import SliderIcon from "../../../../assets/slider";
import UpdateMapping from "../../../../component/updateMapping";
import useFetchData from "../../../../hooks/useFetchData";
import { useModal } from "../../../../hooks/useModal";
import {
  btnClassName,
  btnTextClassName,
  subTitleClassName,
  titleClassName,
  Wrapper,
} from "../integration";
import { ActionIcon } from "rizzui/action-icon";
import { Text } from "rizzui/typography";
import ConsentModal from "../../../../component/consentModal";

export default function HubSpotCard() {
  const { data, isLoading, error } = useFetchData({
    dataType: "hubspot_data_mapping",
    isPost: true,
  });
  const { openModal } = useModal();
  return (
    <Wrapper>
      <HubspotIcon className={""} />
      <div className="w-[176px]">
        <Text className={titleClassName}>Hubspot</Text>
        <Text className={subTitleClassName}>
          Connect to your hubspot CRM workspace
        </Text>
      </div>

      {isLoading ? (
        <Loader variant="threeDot" className="text-[#758599]" />
      ) : data?.data ? (
        <div className="flex justify-between gap-[8px]">
          <ActionIcon variant="text" className={btnClassName}>
            <Text className={btnTextClassName}>Disconnect</Text>
          </ActionIcon>
          <ActionIcon
            variant="text"
            className={`${btnClassName} !w-[39px]`}
            onClick={() =>
              openModal({ view: <UpdateMapping properties={data.data} /> })
            }
          >
            <SliderIcon className={"text-primary-dark"} />
          </ActionIcon>
        </div>
      ) : (
        <ActionIcon
          variant="text"
          className={btnClassName}
          onClick={() => openModal({ view: <ConsentModal type="hubspot" /> })}
        >
          <Text className={btnTextClassName}>Connect CRM</Text>
        </ActionIcon>
      )}
    </Wrapper>
  );
}
